// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import '../static/css/iconfont.css'

//引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

//引入vue-awesome-swiper轮播插件
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

//引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// import  {NoticeBar}  from 'vant';
// import 'vant/lib/notice-bar/style';
// Vue.use(NoticeBar);


// 引入公共common.css
import '../static/mailBox/css/common.css'
import '../static/mailBox/css/reset.css'
import '../static/turnoverCabinet/css/reset.css'
import '../static/turnoverCabinet/css/common.css'
import '../static/css/common.less'

Vue.config.productionTip = false

//vuex
import store from './store'

//language(中英文切换文件定义为公共变量)
import language from '../static/js/utils/language.js'
Vue.prototype.$Language = language

//方格单元格输入框
import validCode from './assets/validCode.vue'
Vue.component('validcode',validCode)

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  language,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js